<template>
  <span
    class="loader-container"
    :style="{
      width: size + 'px',
      height: size + 'px',
    }"
  >
    <span
      v-for="dot in 7"
      :key="dot"
      class="dot"
    >
      <span
        class="dot-before"
        :style="{
          backgroundColor: color,
        }"
      />
    </span>
  </span>
</template>

<script>
export default {
  name: 'AppLoader',
  props: {
    size: {
      type: [
        String,
        Number,
      ],
      default: '70',
    },
    color: {
      type: [
        String,
        Number,
      ],
      default: 'white',
    },
  },
};
</script>

<style lang="scss" scoped>
.loader-container {
  --uib-speed: .9s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .dot {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    width: 100%;

    .dot-before {
      height: 20%;
      width: 20%;
      border-radius: 50%;
      transform: scale(0);
      opacity: 0.5;
      animation: pulse calc(var(--uib-speed) * 1.111) ease-in-out infinite;
      transition: background-color 0.3s ease;
    }

    &:nth-child(2) {
      transform: rotate(45deg);

      .dot-before {
        animation-delay: calc(var(--uib-speed) * -0.875);
      }
    }

    &:nth-child(3) {
      transform: rotate(90deg);

      .dot-before {
        animation-delay: calc(var(--uib-speed) * -0.75);
      }
    }

    &:nth-child(4) {
      transform: rotate(135deg);

      .dot-before {
        animation-delay: calc(var(--uib-speed) * -0.625);
      }
    }

    &:nth-child(5) {
      transform: rotate(180deg);

      .dot-before {
        animation-delay: calc(var(--uib-speed) * -0.5);
      }
    }

    &:nth-child(6) {
      transform: rotate(225deg);

      .dot-before {
        animation-delay: calc(var(--uib-speed) * -0.375);
      }
    }

    &:nth-child(7) {
      transform: rotate(270deg);

      .dot-before {
        animation-delay: calc(var(--uib-speed) * -0.25);
      }
    }

    &:nth-child(8) {
      transform: rotate(315deg);

      .dot-before {
        animation-delay: calc(var(--uib-speed) * -0.125);
      }
    }
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }

  50% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
